import React from 'react';

/**
 * AddOnSelectionModal - Modal for selecting half/full add-on options
 * @param {Object} item - The menu item with add_on_options
 * @param {Function} onSelect - Callback when an option is selected: (addOnType) => void
 * @param {Function} onClose - Callback to close the modal
 */
const AddOnSelectionModal = ({ item, onSelect, onClose }) => {
  if (!item || !item.add_on_options || item.add_on_options.length === 0) {
    return null;
  }

  // Filter out options that don't have a valid portion or price
  const validOptions = item.add_on_options.filter(option => {
    const hasValidPortion = option.portion && option.portion !== '' && option.portion !== '0';
    const hasValidPrice = option.price && parseFloat(option.price) > 0;
    
    console.log('🔍 Filtering add-on option:', {
      add_on_type: option.add_on_type,
      portion: option.portion,
      price: option.price,
      hasValidPortion,
      hasValidPrice,
      isValid: hasValidPortion && hasValidPrice
    });
    
    return hasValidPortion && hasValidPrice;
  });

  // If no valid options remain, don't show the modal
  if (validOptions.length === 0) {
    console.warn('⚠️ No valid add-on options found for item:', item.name_en || item.name);
    onClose();
    return null;
  }

  const handleSelect = (addOnType) => {
    onSelect(addOnType);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]" onClick={onClose}>
      <div 
        className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-900">Select Add-On Option</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-4">
          Choose an option for <span className="font-semibold">{item.name_en || item.name}</span>
        </p>

        <div className="space-y-3">
          {validOptions.map((option, index) => (
            <button
              key={index}
              onClick={() => handleSelect(option.add_on_type)}
              className="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-[#86604D] hover:bg-[#86604D] hover:bg-opacity-5 transition-all duration-200 text-left"
            >
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-base font-bold text-gray-900 capitalize">
                    {option.add_on_type}
                  </div>
                  <div className="text-sm text-gray-500">
                    Portion: {option.portion}
                  </div>
                </div>
                <div className="text-lg font-bold text-[#86604D]">
                  {option.currency} {parseFloat(option.price).toFixed(3)}
                </div>
              </div>
            </button>
          ))}
        </div>

        <button
          onClick={onClose}
          className="w-full mt-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddOnSelectionModal;

